/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_7_AInputs */

const en_pc_faq_7_a = /** @type {(inputs: Pc_Faq_7_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every download button links directly to the official storytold/photocraft releases on GitHub. You can check each file against the published SHA256SUMS.txt.`)
};

const zh_pc_faq_7_a = /** @type {(inputs: Pc_Faq_7_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个下载按钮都直接链接到 GitHub 上官方的 storytold/photocraft Releases，你可以用发布的 SHA256SUMS.txt 校验每个文件。`)
};

/**
* | output |
* | --- |
* | "Every download button links directly to the official storytold/photocraft releases on GitHub. You can check each file against the published SHA256SUMS.txt." |
*
* @param {Pc_Faq_7_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_7_a = /** @type {((inputs?: Pc_Faq_7_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_7_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_7_a(inputs)
	return zh_pc_faq_7_a(inputs)
});
export { pc_faq_7_a as "pc.faq.7.a" }